import { FeatureNameEnum } from '../features';
import { NavigationItemInterface } from '../interfaces';
import { RoutesEnum } from '../routes';

export const leaveNavigationItem: Readonly<NavigationItemInterface> = {
  name: FeatureNameEnum.Leave,
  route: RoutesEnum.Leave,
  icon: 'flight',
};
